<template>
    <section class="flex font-poppins md:flex-col">
         <div >
                <AdminDashboardNav/>
        </div> 
        <div class="w-screen  pl-10 pr-10 md:p-2" >
            <section class="mt-6">
                <div class=" flex justify-between md:flex-col-reverse">
                    <div>
                        <GetDate/>
                        <p class="text-blue-700 font-bold text-2xl">MESSAGES</p>
                    </div>

                    <div class=" mr-10">
                        <Notification/>
                    </div>
                </div>
            </section>

            <section>
                <div class="flex">
                    <p @click="setSelectedTab('the-messages')" :class="{active: selectedTab === 'the-messages'}"  class=" message cursor-pointer mt-6 border-b border-gray-200">Messages</p>
                    <p @click="setSelectedTab('haulage-messages')" :class="{active: selectedTab === 'haulage-messages'}"  class="cursor-pointer mt-6 border-b border-gray-200 ml-8">Haulage Requests</p>
                    <p @click="setSelectedTab('mailing-list')" :class="{active: selectedTab === 'mailing-list'}"  class="cursor-pointer mt-6 border-b border-gray-200 ml-8">Mailing List</p>
                </div>

                
                <component :is="selectedTab"></component>

            </section>
        </div>
    </section>
</template>

<script>
import GetDate from '../GetDate.vue';
import Notification from '../Notification.vue';
import AdminDashboardNav from '../AdminDashboardNav.vue';
import TheMessages from './TheMessages.vue';
import HaulageMessages from './HaulageMessages.vue';
import MailingList from './MailingList.vue';
export default {
    components: {
        GetDate,
        Notification,
        AdminDashboardNav,
        TheMessages,
        HaulageMessages,
        MailingList
    },

    data() {
        return {
            selectedTab: 'the-messages'
        };
    },

    methods: {
        setSelectedTab(tab) {
            this.selectedTab = tab
        }
    }
    
}
</script>

<style scoped>

</style>